// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-main .box{position:relative;width:250px;margin:24px}.home-main .box .title{font-size:22px;font-weight:700;margin-bottom:24px}.home-main .box img{width:250px;margin-top:24px}.home-main .call-to-action a{margin:32px;padding:24px;font-size:18px;border:1px solid #309b30;border-radius:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
